module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/home-property-pin-0c96950faba6fd5162a701b89c698ab4.svg";